import api from './api';
import { ElectronicInvoiceSnapshot } from '../models/ElectronicInvoice';
import { getBackVersion } from '../config';

const getPointInvoice = (
    orderId: number
): Promise<ElectronicInvoiceSnapshot> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/agent/invoice/point/${orderId}`,
    });
};

const getSubscriptionInvoice = (
    subscriptionId: number
): Promise<ElectronicInvoiceSnapshot> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/agent/invoice/subscription/${subscriptionId}`,
    });
};

export default { getPointInvoice, getSubscriptionInvoice };
